import { Unit } from './unit.model';

export class Product {
  id: number = -1;

  unitId: number = -1;
  unit: Unit = new Unit();

  /**
   * The customer whose stock this is. `null` means nobody has said - deliberately not -1, because a
   * sentinel that looks like an account id would be matched against a real customer's charge rates.
   */
  accountId: number = null;

  productClassId: number = -1;
  productGroupId: number = -1;
  warehouseLocationId: number = -1;

  name: string = '';
  displayName: string = '';
  price:number = 0;

  /**
   * Buy-in cost, used for stock valuation. Genuinely optional: part of the
   * warehouse is 3PL, where the goods belong to someone else, and those lines
   * carry a cost of zero. Zero is a real answer here, not a missing one, so an
   * unpriced product is null rather than 0.
   */
  cost:number | null = null;
  active: boolean = false;
  description: string = '';
  supplierCode: string = '';
  sku: string = '';
  weight: number = 0;
  countryOfOrigin: string = '';

  createdBy: number = -1;
  createdAt: string = '';
  updatedAt: string = '';
}
